import Image from 'next/image';
import React from 'react';

type HeroFeatureShowcaseProps = {
  imageUrl: string;
  title: string;
  description: string | string[];
};
const HeroFeatureShowcase: React.FC<HeroFeatureShowcaseProps> = React.memo((props) => {
  const { title, description, imageUrl } = props;
  return (
    <div className="flex flex-col md:flex-row gap-6 items-center my-6 mx-auto">
      <div className="items-center">
        <Image className="md:float-end" src={imageUrl} alt={title} width={500} height={200} />
      </div>
      <div className="flex flex-col max-w-2xl">
        <h2>{title}</h2>
        <p className="text-2xl">{description}</p>
      </div>
    </div>
  );
});
HeroFeatureShowcase.displayName = 'HeroFeatureShowcase';
export default HeroFeatureShowcase;
